// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cost-to-complete-instructions {
    font-size: 0.95rem;
    font-weight: normal;
}
.disabledDiv {
    pointer-events: none;
    -webkit-user-select: none;
            user-select: none;
    opacity: 2;
}

.disabledOverlay {
    overflow: visible;
    position: relative;
    width: 40vw;
    height: 40vh;
    max-width: 100%;
    background-color: gray;
    opacity: 0.5;
    pointer-events: none;
    -webkit-user-select: none;
            user-select: none;
    /* Just for looks*/
    z-index: 1000;
    padding: 20px;
    /* Just for looks*/
}

.full-width {
    width: 100%;
}

.err-highlight {
    color: red;
}

.invalid {
    border: red 1px solid;
}

.no-overflow {
    overflow: hidden;
}

.disabledForm {
    pointer-events: none;
}

.required:after {
    content: " *";
    color: red;
}

:host ::ng-deep .p-dialog-header-close-icon {
    color: white;
    font-size: 2rem;
}

:host ::ng-deep .p-dialog .p-dialog-content {
    max-height: 80vh !important;
    overflow-y: auto !important;
}

:host
    ::ng-deep
    .p-tabview
    .p-tabview-nav
    li
    .p-tabview-nav-link:not(.p-disabled):focus {
    box-shadow: none !important;
}

:host ::ng-deep .init-amt {
    width: 100% !important;
}


.max-width {
    max-width: 100% !important;
    width: 100%;
    overflow-x: hidden !important;
}

.results-table {
    width: 100%;
    overflow-x: hidden !important;
}

:host ::ng-deep .documents-tab-content .p-fileupload {
    width: 100% !important;
}

:host ::ng-deep .documents-tab-content .p-fileupload-buttonbar {
    display: flex !important;
    align-items: center !important;
    justify-content: space-between !important;
    width: 100% !important;
}

:host ::ng-deep .documents-tab-content .p-fileupload-content {
    min-height: 50px !important;
    padding: 0.5rem !important;
}

:host ::ng-deep .p-datatable {
    width: 100% !important;
    min-width: 0 !important;
    overflow-x: hidden !important;
}

:host ::ng-deep .p-datatable-wrapper {
    overflow-x: hidden !important;
}

:host ::ng-deep .p-datatable-table {
    width: 100% !important;
    min-width: 0 !important;
    table-layout: auto !important;
}

.editModalTab {
    width: 1000px !important;
}

.childEditDialog {
    max-width: 1300px !important;
    width: 100%;
    margin-left: auto;
    margin-right: auto;
}

.childEditDialog .max-width {
    max-width: 1600px;
    margin-left: auto;
    margin-right: auto;
}

::ng-deep .p-datatable .p-datatable-header {
    border: none;
}

::ng-deep .p-datatable .p-datatable-tbody > tr > td {
    padding: .5rem;
    vertical-align: middle;
}

::ng-deep .p-datatable .p-datatable-thead > tr > th {
    vertical-align: middle;
    padding: .75rem .5rem;
}

::ng-deep .p-tabview .p-tabview-nav li .p-tabview-nav-link {
    padding: 0.65rem 1rem;
}

.div-spacer{
    height: .5rem;
}

::ng-deep .p-tabview .p-tabview-nav li.p-highlight .p-tabview-nav-link {
    background: lightskyblue !important;
    border: none !important;
    border-radius: 0 !important;
}

::ng-deep .p-tabview .p-tabview-nav li.p-highlight {
    border: none !important;
}

.form-group {
    margin-bottom: 12px;
}


.invoice-col-width-1 {
    width: 23%;
}

.invoice-col-width-2 {
    width: 15%;
}

:host ::ng-deep .modal-footer {
    border: none !important;
    padding: 20px !important;
    display: flex;
    justify-content: flex-end;
    gap: 8px;
}

.cost-to-complete {
    width: 100% !important;
}
`, "",{"version":3,"sources":["webpack://./src/app/search-bond/edit-bond/edit-bond.component.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI,oBAAoB;IACpB,yBAAiB;YAAjB,iBAAiB;IACjB,UAAU;AACd;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,sBAAsB;IACtB,YAAY;IACZ,oBAAoB;IACpB,yBAAiB;YAAjB,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;IACb,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,2BAA2B;IAC3B,2BAA2B;AAC/B;;AAEA;;;;;;IAMI,2BAA2B;AAC/B;;AAEA;IACI,sBAAsB;AAC1B;;;AAGA;IACI,0BAA0B;IAC1B,WAAW;IACX,6BAA6B;AACjC;;AAEA;IACI,WAAW;IACX,6BAA6B;AACjC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,wBAAwB;IACxB,8BAA8B;IAC9B,yCAAyC;IACzC,sBAAsB;AAC1B;;AAEA;IACI,2BAA2B;IAC3B,0BAA0B;AAC9B;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,6BAA6B;AACjC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,6BAA6B;AACjC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,4BAA4B;IAC5B,WAAW;IACX,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;IACtB,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,mCAAmC;IACnC,uBAAuB;IACvB,2BAA2B;AAC/B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB;AACvB;;;AAGA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,uBAAuB;IACvB,wBAAwB;IACxB,aAAa;IACb,yBAAyB;IACzB,QAAQ;AACZ;;AAEA;IACI,sBAAsB;AAC1B","sourcesContent":[".cost-to-complete-instructions {\r\n    font-size: 0.95rem;\r\n    font-weight: normal;\r\n}\r\n.disabledDiv {\r\n    pointer-events: none;\r\n    user-select: none;\r\n    opacity: 2;\r\n}\r\n\r\n.disabledOverlay {\r\n    overflow: visible;\r\n    position: relative;\r\n    width: 40vw;\r\n    height: 40vh;\r\n    max-width: 100%;\r\n    background-color: gray;\r\n    opacity: 0.5;\r\n    pointer-events: none;\r\n    user-select: none;\r\n    /* Just for looks*/\r\n    z-index: 1000;\r\n    padding: 20px;\r\n    /* Just for looks*/\r\n}\r\n\r\n.full-width {\r\n    width: 100%;\r\n}\r\n\r\n.err-highlight {\r\n    color: red;\r\n}\r\n\r\n.invalid {\r\n    border: red 1px solid;\r\n}\r\n\r\n.no-overflow {\r\n    overflow: hidden;\r\n}\r\n\r\n.disabledForm {\r\n    pointer-events: none;\r\n}\r\n\r\n.required:after {\r\n    content: \" *\";\r\n    color: red;\r\n}\r\n\r\n:host ::ng-deep .p-dialog-header-close-icon {\r\n    color: white;\r\n    font-size: 2rem;\r\n}\r\n\r\n:host ::ng-deep .p-dialog .p-dialog-content {\r\n    max-height: 80vh !important;\r\n    overflow-y: auto !important;\r\n}\r\n\r\n:host\r\n    ::ng-deep\r\n    .p-tabview\r\n    .p-tabview-nav\r\n    li\r\n    .p-tabview-nav-link:not(.p-disabled):focus {\r\n    box-shadow: none !important;\r\n}\r\n\r\n:host ::ng-deep .init-amt {\r\n    width: 100% !important;\r\n}\r\n\r\n\r\n.max-width {\r\n    max-width: 100% !important;\r\n    width: 100%;\r\n    overflow-x: hidden !important;\r\n}\r\n\r\n.results-table {\r\n    width: 100%;\r\n    overflow-x: hidden !important;\r\n}\r\n\r\n:host ::ng-deep .documents-tab-content .p-fileupload {\r\n    width: 100% !important;\r\n}\r\n\r\n:host ::ng-deep .documents-tab-content .p-fileupload-buttonbar {\r\n    display: flex !important;\r\n    align-items: center !important;\r\n    justify-content: space-between !important;\r\n    width: 100% !important;\r\n}\r\n\r\n:host ::ng-deep .documents-tab-content .p-fileupload-content {\r\n    min-height: 50px !important;\r\n    padding: 0.5rem !important;\r\n}\r\n\r\n:host ::ng-deep .p-datatable {\r\n    width: 100% !important;\r\n    min-width: 0 !important;\r\n    overflow-x: hidden !important;\r\n}\r\n\r\n:host ::ng-deep .p-datatable-wrapper {\r\n    overflow-x: hidden !important;\r\n}\r\n\r\n:host ::ng-deep .p-datatable-table {\r\n    width: 100% !important;\r\n    min-width: 0 !important;\r\n    table-layout: auto !important;\r\n}\r\n\r\n.editModalTab {\r\n    width: 1000px !important;\r\n}\r\n\r\n.childEditDialog {\r\n    max-width: 1300px !important;\r\n    width: 100%;\r\n    margin-left: auto;\r\n    margin-right: auto;\r\n}\r\n\r\n.childEditDialog .max-width {\r\n    max-width: 1600px;\r\n    margin-left: auto;\r\n    margin-right: auto;\r\n}\r\n\r\n::ng-deep .p-datatable .p-datatable-header {\r\n    border: none;\r\n}\r\n\r\n::ng-deep .p-datatable .p-datatable-tbody > tr > td {\r\n    padding: .5rem;\r\n    vertical-align: middle;\r\n}\r\n\r\n::ng-deep .p-datatable .p-datatable-thead > tr > th {\r\n    vertical-align: middle;\r\n    padding: .75rem .5rem;\r\n}\r\n\r\n::ng-deep .p-tabview .p-tabview-nav li .p-tabview-nav-link {\r\n    padding: 0.65rem 1rem;\r\n}\r\n\r\n.div-spacer{\r\n    height: .5rem;\r\n}\r\n\r\n::ng-deep .p-tabview .p-tabview-nav li.p-highlight .p-tabview-nav-link {\r\n    background: lightskyblue !important;\r\n    border: none !important;\r\n    border-radius: 0 !important;\r\n}\r\n\r\n::ng-deep .p-tabview .p-tabview-nav li.p-highlight {\r\n    border: none !important;\r\n}\r\n\r\n.form-group {\r\n    margin-bottom: 12px;\r\n}\r\n\r\n\r\n.invoice-col-width-1 {\r\n    width: 23%;\r\n}\r\n\r\n.invoice-col-width-2 {\r\n    width: 15%;\r\n}\r\n\r\n:host ::ng-deep .modal-footer {\r\n    border: none !important;\r\n    padding: 20px !important;\r\n    display: flex;\r\n    justify-content: flex-end;\r\n    gap: 8px;\r\n}\r\n\r\n.cost-to-complete {\r\n    width: 100% !important;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
